import React from 'react';
import {connect} from 'react-redux';
import {closeBlockSectionPopup, updateBlockSectionContents} from '../../actions';
import {onSearchBlocks} from '../../thunks';
import BlockSectionEditPopup from './block_section_edit';
import { SECTION_TYPE_BLOCK } from '../../constants';
import { selectSectionSettingInTheSectionEditPopup } from '../../sections/actions';
import { fetchSectionSettings } from '../../../pages/settings/thunks.js';

class BlockPopup extends React.Component {
    componentWillUpdate(nextProps) {
        if (
            nextProps.blockSectionEditOpen === true &&
            this.props.blockSectionEditOpen === false
        ) {
            if (!this.props.allSectionSettings || this.props.allSectionSettings.length === 0) {
                this.props.fetchSectionSettings();
            }
        }
    }

    render() {
        const sectionSettings = this.props.allSectionSettings.filter(
            setting => Number(setting.section_type_id) === SECTION_TYPE_BLOCK
        );

        return (
            <BlockSectionEditPopup
                pageId={this.props.pageId}
                blocks={this.props.sectionBlocks}
                open={this.props.blockSectionEditOpen}
                sectionSettings={sectionSettings}
                selectedSectionSettings={this.props.selectedSectionSettings}
                selectSectionSetting={this.props.selectSectionSetting}
                onHandleSubmit={(block) => {
                    this.props.updateBlockSectionContents(
                        block,
                        this.props.pageId,
                        this.props.blockSectionId,
                        this.props.sectionData,
                        this.props.selectedSettings,
                        this.props.selectedSectionSettings,
                    )
                }}
                onHandleClose={this.props.closeBlockSectionPopup}
                searchCriteria={this.props.blockSearchCriteria}
                onSearchBlocks={this.props.onSearchBlocks }
            />
        )
    }
}

const mapStateToProps = state => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    sectionBlocks: state.blocks.allByTerms,
    blockSectionEditOpen: state.pageBuilder.blockSectionPopup.open,
    blockSectionId: state.pageBuilderSectionPopup.sectionId,
    blockSearchCriteria: state.blocks.blockSearchCriteria,
    selectedSectionSettings: state.pageBuilderSectionPopup.sectionSettings,
    allSectionSettings: state.sectionsSettings.sectionSettings,
});

export default connect(
    mapStateToProps, {
        updateBlockSectionContents,
        closeBlockSectionPopup,
        onSearchBlocks,
        fetchSectionSettings,
        selectSectionSetting: selectSectionSettingInTheSectionEditPopup,
    }
)(BlockPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/block_popup.js